import {Component, inject} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {NovaIconRegistry} from '@rds-nova/angular-icon';
import {ClientActionService} from './shared/client-action.service';
import {ApiService} from './shared/api.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NovaIconRegistry],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly svc = inject(ClientActionService);
  private readonly api = inject(ApiService);
  private readonly router = inject(Router);

  constructor() {
    this.loadToken();
  }

  private loadToken() {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
      this.router.navigate(['/error'], { state: { reason: 'invalid-link' } });
      return;
    }

    this.api.resolveToken(token).subscribe({
      next: (response) => {
        this.svc.setToken(token, response.instructions, new Date(response.expiresAt));
      },
      error: (err) => {
        console.error('Failed to resolve token:', err);

        const reason = err.status === 401 ? 'invalid-link' : 'server-error';
        this.router.navigate(['/error'], { state: { reason } });
      }
    });
  }
}
